// extracted by mini-css-extract-plugin
export var changeIcon = "_7j-4";
export var container = "_7j-0";
export var divider = "_7j-7";
export var externalLinkIcon = "_7j-1";
export var green = "_7j-5";
export var helpCircleIcon = "_7j-3";
export var iconButton = "_7j-2";
export var red = "_7j-6";